export const AUTH0_DOMAIN = 'dev-bou74guj.us.auth0.com';
export const AUTH0_CLIENT_ID = '3TsUwum2FwWjzJhY6qDjbNjNdRPboZD7';
export const API_URL = 'https://api.cloudsecuritylabs.io';
